import { RelayServerTransport } from '~/modules/remote-mic/network/server/transport/relay-server-transport';

export const PARTYKIT_SERVER = import.meta.env.VITE_APP_PARTYKIT_URL;

export class PartyKitServerTransport extends RelayServerTransport {
  public readonly name = 'PartyKit';

  protected getUrl = (roomId: string) => `${PARTYKIT_SERVER}/party/${roomId}`;
}
